import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import { paramTarifMockData } from "../../utils/navbarUtils";

const tarificationParameters = [
  {
    title: "Paramétrage de garanties",
    description:
      "Paramétrer les garanties en définissant pour chacune d'elle la valeur de la prime en fonction des caractéristiques de l'engin et le capital d'indemnisation",
    link: "/garanties",
    button: "Définir une nouvelle garantie",
  },
  {
    title: "Paramétrage de réductions",
    description:
      "Paramétrer les réductions en définissant pour chacune d'elle le taux de réduction, les garanties sur lesquelles elle s'applique",
    link: "/reductions",
    button: "Définir une nouvelle réduction",
  },
  {
    title: "Paramétrage de conversions",
    description:
      "Paramétrer les conversions d'énergie afin de permettre le calcul de la Garantie Responsabilité civile quelque soit la source d'énergie de l'engin",
    link: "/parametres/conversion",
    button: "Définir une nouvelle conversion",
  },
  {
    title: "Paramétrage de catégories",
    description:
      "Paramétrer les différentes catégories d'engins pris en charge par le POOL TPVM-VT GIE",
    link: "/categories",
    button: "Définir une nouvelle catégorie",
  },
  {
    title: "Paramétrage de fractionnement",
    description:
      "Paramétrer les différents fractionnements applicables sur un contrat",
    link: "/parametres/fractionnements",
    button: "Définir un nouveau fractionnement",
  },
  {
    title: "Paramétrage des avenants",
    description:
      "Paramétrer les différents avenants applicables sur un contrat avec les codes.",
    link: "/parametres/avenants",
    button: "Définir un nouvel avenant",
  },
  {
    title: "Paramétrage des carrosseries",
    description:
      "Paramétrer les différents carrosseries d'engins suivant leur catégorie",
    link: "/parametres/carosseries",
    button: "Définir une nouvelle carosserie",
  },
  {
    title: "Paramétrage des usages",
    description:
      "Paramétrer les différents usages d'engins suivant leur catégorie",
    link: "/parametres/usages",
    button: "Définir un nouvel usage",
  },
  {
    title: "Paramétrage des marques",
    description:
      "Paramétrer les différentes marques d'engins suivant leur catégorie",
    link: "/parametres/marques",
    button: "Définir une nouvelle marque",
  },
  {
    title: "Paramétrage des accessoires",
    description:
      "Paramétrer les différents accessoires d'engins suivant leur catégorie",
    link: "/parametres/accessoires",
    button: "Définir des frais d'accessoires",
  },
  {
    title: "Paramétrage des intermédiaires",
    description:
      "Gérer les intermédiaires (apporteurs) et leurs paramètres",
    link: "/intermediaires",
    button: "Gérer les intermédiaires",
  },
  {
    title: "Paramétrage des courtiers",
    description:
      "Gérer les courtiers et leurs paramètres",
    link: "/courtiers",
    button: "Gérer les courtiers",
  },
  {
    title: "Paramétrage des taux de commissions",
    description:
      "Paramétrer les taux de commissions sur les contrats suivant les catégories et les types d'apporteurs",
    link: "/parametres/taux-commissions",
    button: "Définir un taux de commission",
  },
  {
    title: "Paramétrage du numéro de la police",
    description: "Paramétrer le numéro de la police",
    link: "/autre-parametres/numero-police",
    button: "Définir le numéro de la police",
  },
  {
    title: "Paramétrage des taxes",
    description:
      "Paramétrer les différentes taxes suivant les garanties sur lesquelles ils sont applicables",
    link: "/parametres/taxes",
    button: "Définir une taxe",
  },
];

const ParametresTarification = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const renderSearchResults = (results) => {
    return (
      results.map(({ category, items }) => (
        <div key={category} className="px-3 py-2">
          <h6 className="text-muted text-uppercase mb-2">
            {category}
          </h6>
          {items
            .filter((item) =>
              item.name.toLowerCase().includes(searchValue.toLowerCase())
            )
            .map((item, index) => (
              <a
                key={index}
                href={item.url}
                className="dropdown-item d-flex align-items-center gap-2 py-1"
              >
                <i className={`bx ${item.icon} text-muted`}></i>
                <span className="text-truncate">{item.name}</span>
              </a>
            ))}
        </div>
      ))
    );
  }

  useEffect(() => {
    if (searchValue && searchValue?.length > 2) {
      let results = [];
      Object.keys(paramTarifMockData).forEach((key) => {
        const filtered = paramTarifMockData[key].filter((item) =>
          item.name.toLowerCase().includes(searchValue.toLowerCase())
        );
        if (filtered.length) {
          results.push({ category: key, items: filtered });
        }
      });
      setSearchResults(results);
    }
  }, [searchValue]);

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu={"TARIFICATION"} />
        <div className="layout-page">
          <NavBar
            filteredResults={searchResults}
            setFilteredResults={setSearchResults}
            renderSearchResults={renderSearchResults}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row g-4">
                {tarificationParameters.map(({ title, description, link, button }) => (
                  <div key={title} className="col-md-6 col-lg-4">
                    <div className="card h-100 shadow-sm border-0">
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title fw-bold mb-2">{title}</h5>
                        <p className="card-text flex-grow-1 text-muted">{description}</p>
                        <a href={link} className="btn btn-primary mt-2">
                          {button}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default ParametresTarification;
